import {networkService as network} from '@/services'
import store from '@/store'

export const eventRestrictionsService = {
  getEventRestrictions() {
    return new Promise((resolve, reject) => {
      network
        .get(`/event-restrictions/all/en`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getEventRestrictionId(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/event-restrictions/${id}?locale=en`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}